import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { observer } from 'mobx-react';
const TreeBranchMenu = observer(function ({ node, model, onClose, }) {
    return (React.createElement(Menu, { anchorReference: "anchorPosition", anchorPosition: {
            left: node.x,
            top: node.y,
        }, transitionDuration: 0, keepMounted: true, open: Boolean(node), onClose: onClose },
        React.createElement(MenuItem, { dense: true, disabled: true }, node.name),
        React.createElement(MenuItem, { dense: true, onClick: () => {
                model.toggleCollapsed(node.id);
                onClose();
            } }, model.collapsed.includes(node.id)
            ? 'Expand this node'
            : 'Collapse this node'),
        React.createElement(MenuItem, { dense: true, onClick: () => {
                model.showOnly === node.id
                    ? model.setShowOnly(undefined)
                    : model.setShowOnly(node.id);
                onClose();
            } }, model.showOnly === node.id
            ? 'Disable show only this node'
            : 'Show only this node')));
});
export default TreeBranchMenu;
//# sourceMappingURL=TreeBranchMenu.js.map